import { FunctionComponent, PropsWithChildren } from 'react';

export interface IFooterContentTitleProps extends PropsWithChildren {}

const FooterContentTitle: FunctionComponent<IFooterContentTitleProps> = (props) => {
    return <div className="mb-2 text-lg font-bold text-gray-50">{props.children}</div>;
};

export default FooterContentTitle;
